import styled from 'styled-components';

/** Una sola pantalla: no debe crecer más que el viewport (evita scroll por la imagen). */
export const Page = styled.main`
  box-sizing: border-box;
  height: 100vh;
  max-height: 100dvh;
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background: #fafafa;
`;

export const Grid = styled.div`
  flex: 1 1 0;
  min-height: 0;
  width: 100%;
  box-sizing: border-box;
  display: grid;
  gap: 24px;
  /* Mobile: texto arriba; hero abajo ocupa todo el alto restante */
  grid-template-columns: 1fr;
  grid-template-rows: auto minmax(0, 1fr);

  @media (min-width: 900px) {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    grid-template-rows: minmax(0, 1fr);
    gap: 40px;
  }
`;

export const CopyColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  max-width: 470px;
  margin: 0 auto;
  min-height: 0;

  @media (min-width: 900px) {
    justify-self: start;
    align-self: center;
    height: 100%;
    justify-content: center;
    padding: 20px;
  }

  @media (max-width: 899px) {
    padding: 20px;
  }
`;

export const Title = styled.h1`
  margin: 0;
  font-size: 40px;
  font-weight: 700;
  line-height: 1.2;
  color: #1a1a1a;

  @media (min-width: 900px) {
    font-size: 36px;
  }
`;

export const Body = styled.p`
  margin: 0;
  font-size: 22px;
  font-weight: 400;
  line-height: 1.2;
  color: #3a3a3a;
  margin-bottom: 30px;
`;

export const HeroColumn = styled.div`
  width: 100%;
  height: 100%;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  align-self: stretch;
`;

/** Llena el área del hero; cover recorta bordes si la proporción no coincide. */
export const HeroImage = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
`;
